<template>
  <div id="packets">
    <div class="content-wrapper">
      <portal to="action-buttons">
        <ul class="navbar-nav ml-md-auto">
          <li class="nav-item">
            <a href="javascript:;" class="navbar-nav-link" @click="isFilterEnabled = !isFilterEnabled">
              {{ this.$t('event.components.participants.navbar.filterRecord') }}
              <i class="fas fa-search ml-1" :class="$store.state.packets.filter.searchTerm != null && $store.state.packets.filter.searchTerm != '' ? 'animate__animated animate__pulse animate__infinite text-info' : ''"></i>
            </a>
          </li>

          <li class="nav-item">
            <a href="javascript:;" @click="categoryModal = true" class="navbar-nav-link">
              {{ this.$t('event.components.participants.navbar.category') }}
            </a>
          </li>

          <li class="nav-item">
            <a
              href="javascript:;"
              class="navbar-nav-link"
              @click="
                updateForm = null;
                modalVisible = true;
              "
            >
              {{ this.$t('event.components.participants.navbar.add') }}
              <i class="icon-plus3 ml-1"></i>
            </a>
          </li>
        </ul>
      </portal>
      <div class="content animated fadeIn">
        <transition name="slide-fade">
          <div v-if="isFilterEnabled" class="filter-card card card-collapsed">
            <div class="card-header header-elements-inline">
              <h5 class="card-title">{{ this.$t('event.components.participants.navbar.filterRecord') }}</h5>

              <div class="header-elements">
                <div class="list-icons">
                  <el-button-group>
                    <el-button size="mini" @click="$store.state.packets.filter.searchTerm = ''" round>{{ $t('event.buttons.reset') }}</el-button>
                    <el-button size="mini" type="danger" @click="isFilterEnabled = false" round>{{ $t('event.buttons.close') }}</el-button>
                  </el-button-group>
                </div>
              </div>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="form-group col-md-12">
                  <el-input clearable v-model="$store.state.packets.filter.searchTerm" :placeholder="$t('event.textbox.speakerFilter')"></el-input>
                </div>
              </div>
            </div>
          </div>
        </transition>

        <div class="card">
          <div class="card-header header-elements-inline" style="padding-bottom:0px;">
            <h5 class="card-title">{{ this.$t('event.menu.registrationpackages.title') }}</h5>

            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.helpdesk')" placement="top">
                  <el-button @click="$helpMe(null)" icon="fas fa-life-ring" size="mini"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button icon="fas fa-redo-alt" size="mini"></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>

          <PageCountInfo :total="$store.state.packets.filter.total" :skip="skip" :take="take" />

          <el-table v-loading="$store.state.packets.loading" ref="multipleTable" :data="$store.state.packets.items" style="width: 100%" @selection-change="handleSelectionChange" :row-class-name="tableRowClassName">
            <el-table-column :label="$t('event.table.queue')" property="orderNO" width="60"></el-table-column>
            <el-table-column property="title" :label="$t('event.table.title')" min-width="120">
              <template slot-scope="scope">
                <a
                  href="javascript:;"
                  @click="
                    $store.state.payments.filter.packetIDs = [scope.row.id];
                    $router.push({ name: 'payments' });
                  "
                  >{{ scope.row.title }}</a
                >
              </template>
            </el-table-column>

            <el-table-column min-width="170" property="color" :label="$t('event.table.label')">
              <template slot-scope="scope">
                <div style="display: flex; flex-direction: row; align-items: center; justify-content: flex-start">
                  <span style="width: 20px; height: 20px; display: inline-block; border-radius: 50%; margin-right: 5px" :style="'background-color: ' + $store.state.tags.items.find((k) => k.id == scope.row.tagID).color"></span>
                  <span>
                    {{ $store.state.tags.items.find((k) => k.id == scope.row.tagID).title }}
                  </span>
                </div>
              </template>
            </el-table-column>

            <el-table-column property="price" :label="$t('event.table.price')" min-width="120">
              <template slot-scope="scope">
                <span>{{ $formatMoney(scope.row.price) }}</span>
                <span>
                  {{ $enums.currency.find((k) => k.value == scope.row.currency).title }}
                </span>
              </template>
            </el-table-column>

            <el-table-column property="price" :label="$t('event.table.kdv')" min-width="120">
              <template slot-scope="scope">
                <span v-if="$i18n.locale == 'tr'">%{{ scope.row.taxRate }}</span>
                <span v-else>{{ scope.row.taxRate }}%</span>
              </template>
            </el-table-column>

            <el-table-column property="price" :label="$t('event.table.salesStock')" min-width="120">
              <template slot-scope="scope">
                <span>
                  <strong>{{ scope.row.usage }} / </strong>
                  <span>{{ scope.row.stock }}</span>
                </span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('event.table.onAir')" width="170">
              <template slot-scope="scope">
                <el-switch @change="statusChanged($event, scope.$index)" v-model="$store.state.packets.items[scope.$index].isActive" :active-text="$t('event.variables.yes')" :inactive-text="$t('event.variables.no')"></el-switch>
              </template>
            </el-table-column>
            <el-table-column align="center" :label="$t('event.table.processes')" width="110" fixed="right">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" :content="$t('event.table.edit')" placement="top">
                  <el-button
                    type="primary"
                    icon="fas fa-pen"
                    circle
                    size="mini"
                    @click="
                      updateForm = JSON.parse(JSON.stringify(scope.row));
                      modalVisible = true;
                    "
                  ></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.table.delete')" placement="top">
                  <el-popconfirm @confirm="deleteItem(scope.$index)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                    <el-button slot="reference" type="danger" icon="fas fa-trash" circle size="mini"></el-button>
                  </el-popconfirm>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="$store.state.packets.filter.page" :page-sizes="[20, 30, 40, 50]" :page-size="100" layout="total, sizes, prev, pager, next, jumper" :total="$store.state.packets.filter.total"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog :close-on-click-modal="false" :visible.sync="modalVisible" :title="$t('editPack')" width="80%">
      <PacketAddUpdate @deleteMe="deleteItem" @closeMe="modalVisible = false" @itemUpdated="itemUpdated" @itemAdded="itemAdded" :data="updateForm" />
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :visible.sync="categoryModal" :title="$t('event.components.participants.navbar.category')" width="80%">
      <PacketCategory @closeMe="categoryModal = false" />
    </el-dialog>
  </div>
</template>

<script>
import PacketCategory from "../../components/PacketCategory";
import PacketAddUpdate from "../../components/PacketAddUpdate";
import ExcelImport from "../../components/ExcelImport";
import axios from "axios";
import PageCountInfo from "../../components/PageCountInfo";
import $ from "jquery";
export default {
  metaInfo: {
    title: "Sales packages",
  },
  components: { PacketAddUpdate, ExcelImport, PageCountInfo, PacketCategory },
  name: "Packets",
  data() {
    return {
      categoryModal: false,
      modalVisible: false,
      updateForm: null,
      isFilterEnabled: false,
      timeout: null,
      excelDialog: false,
      helpUrl: this.$helpUrl + "areamaps",
      widgetUrl:
        "https://cdn.holacon.com/widgets/event-speakers.html?applicationID=5e2b3b73286bd618b47d1e6e&amp;eventID=5e30227b83089521b86ef7bf",
      excelTemplateUrl:
        this.$excelTemplateUrl + "sample/SpeakerExcel/SpeakerImportSample.xlsx",
      tagModalVisible: false,
    };
  },
  methods: {
    itemUpdated(item) {
      var index = this.$store.state.packets.items.findIndex(
        (k) => k.id == item.id
      );
      if (index != -1) {
        this.$store.state.packets.items.splice(index, 1, item);
      }
    },

    handleSizeChange(take) {
      this.$store.commit("setPacketTake", take);
    },
    handleCurrentChange(page) {
      $("html, body").animate({ scrollTop: 0 }, 350);
      this.$store.commit("setPacketPage", page);
    },
    deleteItem(index) {
      this.$store.dispatch("deletePacket", { index, context: this });
    },
    statusChanged(value, index) {
      this.$store.dispatch("togglePacket", { index, value });
    },
    handleSelectionChange(items) {
      this.$store.commit("setSelectedPackets", items);
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isActive) {
        return "row-active";
      }
      return "row-passive";
    },
  },
  created() {},
  computed: {
    skip() {
      return (
        (this.$store.state.packets.filter.page - 1) *
        this.$store.state.packets.filter.take
      );
    },
    take() {
      return this.skip + this.$store.state.packets.items.length;
    },
  },
  watch: {
    "$store.state.packets.filter.searchTerm": function() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
      }, 500);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/event/Packets.vue